// extracted by mini-css-extract-plugin
export default {"Checkbox":"BaseCheckbox_Checkbox__s3MTI","Checkmark":"BaseCheckbox_Checkmark__FAx1C"};